/**
 * 科室模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';
import axios from 'axios';

// 获取科室列表
export const postList = (params) => {
  return req.get('/system/post/list', params);
}

// 获取科室列表
export const postList1 = (doctorId) => {
  return req.get(`/system/post/listByDoctorId/${doctorId}`);
}

// 获取科室详情
export const postInfo = (postId) => {
  return req.get(`/system/post/${postId}`);
}

// 新增科室
export const postAdd = (params) => {
  return req.post('/system/post', params);
}

// 修改科室信息
export const postEdit = (params) => {
  return req.put('/system/post', params);
}

// 删除科室信息
export const postDelete = (postId) => {
  return req.delete(`/system/post/${postId}`);
}

// 获取医生列表
export const doctorData = (postId) => {
  return req.get(`/system/post/doctors/${postId}`);
}

// 新增或删除医生
export const saveDoctors = (params) => {
  return req.post(`/system/post/addDoctors`, params);
}

// 新增科室
export const postDragSort = (params) => {
  return req.post('/system/post/dragSort', params);
}
//上传科室图片
export const uploadTemporaryFile=(params)=>{
  return req.post('/upload/fdfs/file/upload/fdfs', params,'/xl');
}


//新增新科室
export const addDepartment = (params) => {
  return req.post('/system/department/add', params);
}
//修改新科室
export const editDepartment = (params) => {
  return req.post('/system/department/edit', params);
}
//删除新科室
export const deleteDepartment = (params) => {
  return req.post(`/system/department/delete`,params);
}
//获取新科室列表
export const getDepartmentPage = (params) => {
  return req.post('/system/department/page',params);
}
//获取新科室详情
export const getDepartmentInfo = (params) => {
  return req.get(`/system/department/detail`,params);
}
//查询新科室已绑定医生
export const getDepartmentDoctors = (params) => {
  return req.get(`/system/department/doctors`,params);
}
//绑定新科室医生
export const bindDepartmentDoctors = (params) => {
  return req.post(`/system/department/doctors/bind`,params);
}